import { Modal } from "antd";
import "../../styles/AIInsightModal.css";
import {
  CloseOutlined,
  ExclamationOutlined,
  CheckOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { useFetchFunction } from "../../utils/hooks/UseFetchUrl";
import { useEffect } from "react";

const AIInsightModal = ({ open, onClose, auditStoreId }) => {
  const { loading, data, getData } = useFetchFunction();

  useEffect(() => {
    if (!open || !auditStoreId) return;

    getData(`audit_store/${auditStoreId}/ai_insights`);
  }, [open, auditStoreId]);

  const auditData = Array.isArray(data) ? data[0] : null;
  // const quickInsight = auditData?.report_summary;

  return (
    <Modal
      className="ai-insight-modal"
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={600}
      loading={loading}
    >
      <div className="ai-insight-header">
        <div className="ai-insight-title-wrap">
          <div className="rbAiBtn">
            <span className="geminiSparkle">✦</span>
          </div>
          <h3 className="ai-insight-title">AI Analysis</h3>
        </div>
        <button className="ai-insight-close-btn" onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>
      <div className="ai-insight-divider" />

      <div className="ai-insight-sub-header">
        <div className="ai-insight-meta-row">
          <span className="code">{auditData?.audit?.store?.name ?? "N/A"}</span>
          <span className="sep">|</span>
          <span className="dealer">
            {auditData?.audit?.store?.client?.name ?? "N/A"}
          </span>
        </div>
        <div className="ai-insight-score-row">
          <span className="label">Overall Score</span>
          <span className="ai-insight-score-badge">
            {auditData?.audit_store_percentage != null
              ? `${auditData.audit_store_percentage}%`
              : "N/A"}
          </span>
        </div>
      </div>

      {/* <div className="ai-insight-section-heading">Quick Insight</div> */}
      {/* <p className="ai-insight-paragraph">{quickInsight}</p> */}
      <div className="ai-insight-divider" />
      <div className="ai-insight-section-heading">Key Findings</div>
      <div className="ai-insight-findings-list">
        {/* What went Well */}
        <div className={`ai-insight-finding-item success`} key={1}>
          <div className={`ai-insight-icon-wrap success`}>
            <CheckOutlined />
          </div>
          <div className="ai-insight-finding-text">
            <div className="ai-insight-finding-title">What went well</div>
            <ul className="ai-insight-bullets">
              {auditData?.went_well?.map((ww, i) => (
                <li key={i}>{ww?.point}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* What didn't go Well */}
        <div className={`ai-insight-finding-item critical`} key={1}>
          <div className={`ai-insight-icon-wrap critical`}>
            <ExclamationOutlined />
          </div>
          <div className="ai-insight-finding-text">
            <div className="ai-insight-finding-title">What didn't go well</div>
            <ul className="ai-insight-bullets">
              {auditData?.did_not_go_well?.map((dngw, i) => (
                <li key={i}>{dngw?.point}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* What can be improved */}
        <div className={`ai-insight-finding-item warning`} key={1}>
          <div className={`ai-insight-icon-wrap warning`}>
            <StarOutlined />
          </div>
          <div className="ai-insight-finding-text">
            <div className="ai-insight-finding-title">What can be improved</div>
            <ul className="ai-insight-bullets">
              {auditData?.can_be_improved?.map((cbi, i) => (
                <li key={i}>{cbi?.point}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AIInsightModal;
